<template>
  <div class="control is-vertical">
    <div class="control is-grouped">
      <p :class="{'control': true, 'is-expanded': true, 'is-loading': inProgress}">
        <label class="label">Send Reconfirmation E-Mail</label>
        <input :class="{'input': true, 'is-danger': errors.has('email')}" name="email" id="email" type="text" placeholder="E-mail" v-model="reconfirm.email" v-validate data-vv-rules="required|email">
        <span v-show="errors.has('email')" class="help is-danger">{{ errors.first('email') }}</span>
      </p>
      <a :class="{'button': true, 'is-success': true, 'is-disabled': errors.any(), 'is-loading': inProgress}" style="margin-top: 20px;" @click="reconfirmEmailService">Send</a>
    </div>
  </div>
</template>

<script>
  import message from '../../utils/message'
  export default {
    props: {
      service: {
        type: Object
      }
    },
    data () {
      return {
        reconfirm: {
          service_id: '',
          email: ''
        },
        inProgress: false
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.reconfirm.service_id = this.service.id
      })
    },
    methods: {
      reconfirmEmailService () {
        this.$validator.validateAll().then(() => {
          if (this.errors.items.length === 0) {
            this.inProgress = true
            this.$http.post(this.$store.state.config.apiURL + '/services/reconfirm_email', this.reconfirm).then((response) => {
              this.$emit('reload')
              this.message('success', 'Success', 'The reconfirmation e-mail was successfully sent')
              this.reconfirm.email = ''
              this.inProgress = false
            }, (response) => {
              this.message('danger', 'Error', response.body)
              this.inProgress = false
            })
          }
        })
      },
      message (type, title, content) {
        let propsData = {
          title: title,
          message: content,
          type: type,
          direction: 'down',
          duration: 4500,
          showCloseButton: true
        }
        message.openMessage(propsData)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ReconfirmEmail.vue?c9ed9b0a